// extracted by mini-css-extract-plugin
module.exports = {"icons":"contractualaccountselect_icons__Gm_8D","textContent":"contractualaccountselect_textContent__bN1F2"};